import INTERFACE from "../setting/interface_docx"

export default function buildSettingDocx() {
  let ret = {};
  ret.type = "docx";
  ret.pref = "";
  ret.municipality = "";
  ret.font = "standard";
  ret.contents = buildSettingForContents(INTERFACE);
  return ret;
}

function buildSettingForContents(contents) {
  let ret = {};

  contents.forEach((item) => {
    ret[item.path] = true;
  })

  return ret;
}
